import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';

export const Header = ({ language, setLanguage, translations }) => {
  const location = useLocation();
  const t = translations[language];

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_3b7d1c0d-e4e6-424e-b604-6bb2d8c76c25/artifacts/bpyuhave_logo.jpg" 
              alt="Tasarı Bilgisayar" 
              className="h-12 w-auto"
            />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              {t.nav.home}
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              {t.nav.services}
            </button>
            <button
              onClick={() => scrollToSection('partners')}
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              {t.nav.partners}
            </button>
            <Link
              to="/references"
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              {t.nav.references}
            </Link>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              {t.nav.contact}
            </button>
          </nav>

          <div className="flex items-center gap-2">
            <Button
              variant={language === 'tr' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setLanguage('tr')}
              className="w-10 h-10 p-0 text-lg"
            >
              🇹🇷
            </Button>
            <Button
              variant={language === 'en' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setLanguage('en')}
              className="w-10 h-10 p-0 text-lg"
            >
              🇬🇧
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
